import {Roles} from "./index";

type RoutesAccessRightsMap = { [route: string]: Roles[] };

export const routesAccessRights: RoutesAccessRightsMap = {
  "/dashboard": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "operator_user",
    "funder_user",
    "carrier_admin",
    "carrier_user",
    "visitor_user",
    "visitor_admin",
  ],
  "/dashboard?operatorFilter": [
    "admin",
    "super_admin",
    "carrier_admin",
    "carrier_user",
    "visitor_user",
    "visitor_admin",
  ],
  "/dashboard?carrierFilter": [
    "admin",
    "super_admin",
    "operator_admin",
    "operator_user",
    "visitor_user",
    "visitor_admin",
  ],
  "/bonus": ["admin", "super_admin", "operator_admin", "operator_user"],
  "/bonusPayment": ["admin", "user"],
  "/projects": ["admin", "super_admin", "funder_user"],
  "/projects/edit": ["admin", "super_admin"],
  "/organizations": ["admin", "super_admin"],
  "/organizations/:orgnizationId": [],
  "/organizations/add": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/edit": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/users/add": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/users/edit": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/documents/convention": [
    "admin",
    "super_admin",
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/documents/convention/sign": [
    "operator_admin",
    "funder_admin",
    "carrier_admin",
    "operator_admin_onboarding",
  ],
  "/organizations/documents": [],
  "/notifications": [],
  "/notificationRouter": [],
  "/archives": [],
  "/api": ["operator_admin", "carrier_admin", "tms_admin"],
  "/reports": ["user", "admin", "carrier_admin", "carrier_user"],
  "/campaignDelivery": ["admin"],
  "/flux": ["admin", "super_admin", "read_flux_map"],
  "/geozones": ["admin", "super_admin"],
  "/geozones/add": ["admin", "super_admin"],
  "/deliveryexport": ["admin", "super_admin"],
  "/tours/import": ["admin", "super_admin"],
  "/csv/scanner": [
    "admin",
    "super_admin",
    "operator_admin",
    "operator_user",
    "carrier_admin",
    "carrier_user",
    "tms_admin",
    "tms_user",
  ],
  "/analysis/received-data": ["admin", "super_admin"],
  "/analysis/delivery-points-export": ["admin", "super_admin"],
};
